const checkType = (data: any): any => {
  //先检查类型，返回的是一个Array，或者Object
  return Object.prototype.toString.call(data).slice(8, -1);
};
const deepClone = (target: any): any => {
  //开始深拷贝
  const targetType: any = checkType(target);
  let result: any;
  if (targetType === "Object") {
    result = {};
  } else if (targetType === "Array") {
    result = [];
  } else {
    return target;
  }
  for (const i in target) {
    const value: any = target[i];
    const valueType = checkType(value);
    if (valueType == "Object" || valueType == "Array") {
      result[i] = deepClone(value); //递归操作
    } else {
      result[i] = value;
    }
  }
  return result;
};


// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
const getNowTime = () => {
  const time = new Date();
  const year: number | string = time.getFullYear();
  let month: number | string = time.getMonth() + 1;
  let day: number | string = time.getDate();
  let hour: number | string = time.getHours();
  let min: number | string = time.getMinutes();
  let sec: number | string = time.getSeconds();
  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;
  hour = hour < 10 ? `0${hour}` : hour;
  min = min < 10 ? `0${min}` : min;
  sec = sec < 10 ? `0${sec}` : sec;
  return `${year}-${month}-${day} ${hour}:${min}:${sec}`;
};


//日期格式化 只获取年月日
const formatTime = (val: string):string => val? val.split(" ")[0]: '';


//递归
const setTreeData = (data: any): any => {
  const cloneData = JSON.parse(JSON.stringify(data)); // 对源数据深度克隆
  const tree = cloneData.filter((father: any) => {
    //循环所有项
    const branchArr = cloneData.filter((child: any) => {
      return father.id == child.reid; //返回每一项的子级数组
    });
    if (branchArr.length > 0) {
      father.children = branchArr; //如果存在子级，则给父级添加一个children属性，并赋值
    }
    return father.reid == 0; //返回第一层
  });
  return tree; //返回树形数据
};



function getUserInfo(){
  let userInfo = localStorage.getItem('userInfo')
  if(userInfo){
    return JSON.parse(userInfo)
  }else{
    return null
  }
}

function getToken(){
  let userTokenStr = localStorage.getItem('userToken')
  let userToken = ""
  if(userTokenStr){
    userToken = JSON.parse(userTokenStr)
  }
  return userToken
}



export {
  deepClone,getNowTime,formatTime,setTreeData,getUserInfo,getToken
}